import { UiTagVariant } from '@infuse/ui/domain';
import { Status } from '@infuse/api/cpms/operator';

export const StatusColors: { [key: string]: UiTagVariant } = {
  [Status.UNKNOWN]: 'eVinactive',
  [Status.AVAILABLE]: 'eVavailable',
  [Status.OCCUPIED]: 'eVcharging',
  [Status.RESERVED]: 'success',
  [Status.INOPERATIVE]: 'warning',
  [Status.FAULTED]: 'eVerror',
  [Status.OFFLINE]: 'neutral'
};

export const StatusIcon: { [key: string]: [string, string] } = {
  [Status.UNKNOWN]: ['fal', 'triangle-exclamation'],
  [Status.AVAILABLE]: ['fal', 'circle-check'],
  [Status.OCCUPIED]: ['fal', 'bolt'],
  [Status.RESERVED]: ['fal', 'circle-check'],
  [Status.INOPERATIVE]: ['fal', 'wrench'],
  [Status.FAULTED]: ['fal', 'xmark'],
  [Status.OFFLINE]: ['fal', 'circle-xmark']
};
